import styled from 'styled-components';

import { Text } from '@dreryk/react-components';

const BULLET_SYMBOL = 2022;

export const StyledText = styled(Text)`
   &::before {
      content: '\\${BULLET_SYMBOL}';
      position: absolute;
      inset: 0 0 0 7px;
   }

   position: relative;
   padding-left: 18px;
`;

StyledText.displayName = 'StyledText';
